'use strict';

var processInclude = require('./components/processInclude');
var jqueryDatepicker = require('jquery-datepicker');
jqueryDatepicker($);

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./giftcard/checkBalance'));
    processInclude(require('./giftcard/details'));
    processInclude(require('./giftcard/giftCardCheckout'));
});
